var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJudge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3413 12.84C13.2146 12.84 13.088 12.7933 12.988 12.6933L9.68797 9.39329C9.49464 9.19996 9.49464 8.87996 9.68797 8.68663C9.8813 8.49329 10.2013 8.49329 10.3946 8.68663L13.6946 11.9866C13.888 12.18 13.888 12.5 13.6946 12.6933C13.5946 12.7933 13.468 12.84 13.3413 12.84Z",
    fill: "#23262F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74094 12.2867C6.25428 12.2867 5.78761 12.0934 5.44761 11.7467L2.62094 8.92003C1.9076 8.2067 1.9076 7.04002 2.62094 6.32669L7.33428 1.61337C8.04761 0.900036 9.21428 0.900036 9.92761 1.61337L12.7543 4.44003C13.1009 4.7867 13.2943 5.2467 13.2943 5.73336C13.2943 6.22003 13.1009 6.6867 12.7543 7.0267L8.04094 11.74C7.69427 12.1 7.23428 12.2867 6.74094 12.2867ZM8.62761 2.08002C8.41428 2.08002 8.20094 2.16002 8.04094 2.32669L3.32761 7.04003C3.00095 7.36669 3.00095 7.89335 3.32761 8.22002L6.15427 11.0467C6.46761 11.36 7.01428 11.36 7.33428 11.0467L12.0476 6.33336C12.2076 6.17336 12.2943 5.96669 12.2943 5.74669C12.2943 5.52669 12.2076 5.31335 12.0476 5.16002L9.22094 2.33336C9.05428 2.16003 8.84094 2.08002 8.62761 2.08002Z",
    fill: "#23262F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 14.5H1.33203C1.0587 14.5 0.832031 14.2733 0.832031 14C0.832031 13.7267 1.0587 13.5 1.33203 13.5H5.33203C5.60536 13.5 5.83203 13.7267 5.83203 14C5.83203 14.2733 5.60536 14.5 5.33203 14.5Z",
    fill: "#23262F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08667 10.4933C8.96 10.4933 8.83334 10.4466 8.73334 10.3466L4.02 5.63328C3.82667 5.43995 3.82667 5.11995 4.02 4.92662C4.21333 4.73328 4.53333 4.73328 4.72666 4.92662L9.44 9.63993C9.63334 9.83327 9.63334 10.1533 9.44 10.3466C9.34667 10.4466 9.21334 10.4933 9.08667 10.4933Z",
    fill: "#23262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudge);
export default __webpack_public_path__ + "static/media/judge.168b554869c1270aa873896288e7920b.svg";
export { ForwardRef as ReactComponent };